/*
 * VULCAN
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/directoryMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Directory. */
var Directory = /** @class */ (function () {
    /**
     * Create a Directory.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Directory(client) {
        this.client = client;
    }
    Directory.prototype.searchDirectoryUsers = function (query, options, callback) {
        return this.client.sendOperationRequest({
            query: query,
            options: options
        }, searchDirectoryUsersOperationSpec, callback);
    };
    return Directory;
}());
export { Directory };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var searchDirectoryUsersOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/directory/users/search",
    queryParameters: [
        Parameters.query,
        Parameters.skip,
        Parameters.top,
        Parameters.count
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DirectoryUserSearchResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=directory.js.map